// Причина отказа по коду из ответа загрузки марок.
// Бэк для разных ТГ пишет по-разному («КМ не найден», «Код не найден»), а для кода из
// другого заказа тоже отвечает «не найден», хотя присылает id/status/orderId найденного кода.
const NOT_FOUND_RE = /^(км|код)(\s+маркировки)?\s+не\s+найден|табылмады/i;

export const formatMarkReason = (
  row: { reason?: unknown; id?: unknown; orderId?: unknown } | null | undefined,
  t: (key: string) => string,
): string => {
  const reason = String(row?.reason ?? "").trim();
  if (!reason) return "-";
  if (!NOT_FOUND_RE.test(reason)) return reason;

  const isFound = row?.id != null && row?.orderId != null;
  return isFound
    ? t("documents_upload.reason_other_order")
    : t("documents_upload.reason_not_found");
};
